import React, { useContext, useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserIcon from "../assets/icons/sidebarIcons/aboutUs.svg";
import LogoPic from "../assets/images/Logo.png";
import ShopName from "../assets/icons/sidebarIcons/ShopNameWhite.svg";
import { UserContext } from "../pages/UserContext";
import order from "../assets/icons/sidebarIcons/order.svg";
import Rate from "../assets/icons/footerIcons/rate.svg";
import banner from "../assets/icons/sidebarIcons/eye.svg";
import profile from "../assets/icons/footerIcons/profile.svg";
import settingsWheel from "../assets/icons/sidebarIcons/settings.svg";
import addCustomer from "../assets/icons/sidebarIcons/aboutUs.svg";
import message from "../assets/icons/sidebarIcons/message.svg";
import Promotions from "../assets/icons/sidebarIcons/promotion.svg";
import categories from "../assets/icons/sidebarIcons/categories.svg";
import ShopNameSVG from "./ShopNameSVG";

const AdminSidebar = ({ isOpen, onClose, userName }) => {
  const { logout, user } = useContext(UserContext);
  const navigate = useNavigate();
  const sidebarRef = useRef(null);
  const [settings, setSettings] = useState({
    shopName: "Shop Name",
    shopLogo: "",
    whatsappNumber: "",
  });

  const handleLogout = () => {
    logout();
    onClose();
    navigate("/login");
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setSettings({
            shopName: data.shop_name || "Shop Name",
            shopLogo: data.logo_white || "/assets/images/default-logo.png",
            whatsappNumber: data.whatsapp_number || "",
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching settings:", error);
      });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        event.stopPropagation();
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  const [pendingOrders, setPendingOrders] = useState(0);

  useEffect(() => {
    if (isOpen) {
      const fetchOrders = async () => {
        const token = localStorage.getItem("token");
        try {
          const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/order`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
          const data = await response.json();
          const pendingCount = data.filter((order) => order.order_status === null).length;
          setPendingOrders(pendingCount);
        } catch (error) {
          console.error("Error fetching orders:", error);
        }
      };
      fetchOrders();
    }
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-10"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            ref={sidebarRef}
            className={`fixed top-0 left-0 h-full w-64 bg-gray-100 shadow-lg transform ${
              isOpen ? "translate-x-0" : "-translate-x-full"
            } transition-transform duration-300 ease-in-out z-20 flex flex-col overflow-y-auto`}
          >
            {/* Scrollable Content */}
            <div className="flex-1">
              {/* Sidebar Header */}
              <div className="bg-[rgb(89,10,10)] text-white p-1">
                <button className="text-white text-2xl absolute pl-2" onClick={onClose}>
                  ×
                </button>
                <div className="flex grid-cols-3 p-4 items-center mt-4">
                  <img
                    src={settings.shopLogo}
                    alt="Shop Logo"
                    className="h-20 w-15 object-contain"
                  />
                  <ShopNameSVG shopName={settings.shopName} colour="white" />
                </div>
                <Link to="/Admin-profile" onClick={onClose}>
                  <div className="flex justify-left">
                    <div className="flex flex-row bg-white space-x-6 rounded-lg px-4 py-1 shadow-md">
                      <div className="text-sm text-black text-center">{userName}</div>
                      <img
                        src={user.profile_picture || profile}
                        alt="User Profile"
                        className="h-6 w-6 object-cover rounded-full border border-gray-300"
                      />
                    </div>
                  </div>
                </Link>
              </div>

              {/* Menu Items */}
              <div className="p-4 space-y-6">
                <Link to="/update-rate" onClick={onClose}>
                  <div className="flex items-center space-x-5 mb-5">
                    <img src={Rate} alt="Cart" className="h-6 w-6" />
                    <span className="text-black font-normal">Manage Gold Rate</span>
                  </div>
                </Link>
                <Link to="/Loyalty-customers" onClick={onClose}>
                  <div className="flex items-center space-x-5 mb-5">
                    <img src={UserIcon} alt="Notification" className="h-6 w-6" />
                    <span className="text-black font-normal">Loyalty Customers</span>
                  </div>
                </Link>
                <Link to="/orders" onClick={onClose}>
                  <div className="flex items-center space-x-5 mb-5 relative">
                    <div className="relative">
                      <img src={order} alt="Orders" className="h-6 w-6" />
                      {pendingOrders > 0 && (
                        <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                          {pendingOrders}
                        </span>
                      )}
                    </div>
                    <span className="text-black font-normal">Orders</span>
                  </div>
                </Link>
                <Link to="/banners" onClick={onClose}>
                  <div className="flex items-center space-x-5 mb-5">
                    <img src={banner} alt="About us" className="h-6 w-6" />
                    <span className="text-black font-normal">Banners</span>
                  </div>
                </Link>
                <Link to="/add-customer" onClick={onClose}>
                  <div className="flex items-center space-x-5 mb-5">
                    <img src={addCustomer} alt="About us" className="h-6 w-6" />
                    <span className="text-black font-normal">Add customer</span>
                  </div>
                </Link>
                <Link to="/OfferMessage" onClick={onClose}>
                  <div className="flex items-center space-x-5 mb-5">
                    <img src={Promotions} alt="About us" className="h-6 w-6" />
                    <span className="text-black font-normal">Promotions</span>
                  </div>
                </Link>
                <Link to="/manage-category" onClick={onClose}>
                  <div className="flex items-center space-x-5 mb-5">
                    <img src={categories} alt="About us" className="h-6 w-6" />
                    <span className="text-black font-normal">Categories</span>
                  </div>
                </Link>
                <Link to="/sms-settings" onClick={onClose}>
                  <div className="flex items-center space-x-5 mb-5">
                    <img src={message} alt="About us" className="h-6 w-6" />
                    <span className="text-black font-normal">SMS configuration</span>
                  </div>
                </Link>
                <Link to="/settings" onClick={onClose}>
                  <div className="flex items-center space-x-5 mb-5">
                    <img src={settingsWheel} alt="About us" className="h-6 w-6" />
                    <span className="text-black font-normal">Settings</span>
                  </div>
                </Link>
              </div>
            </div>

            {/* Fixed Logout Button */}
            <div className="p-4 bg-gray-200">
              <button
                onClick={handleLogout}
                className="w-full bg-[rgb(89,10,10)] text-white p-2 rounded-md flex items-center justify-center space-x-2"
              >
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminSidebar;
